import config from "../../store/sqftConfig";
import {enableRegularMode, enableSlabMode} from "../../store/canvasHelper";
import store from "../../../../../../store";
import SqftStore from "../../store/sqftStore";
import {showSlabTool} from "../../../../../../actions/sqftSlabFunctions";
import SlabWorkspace from "../slab/slabWorkspace";
import {renderSlabRightPart} from "../slab/sqftSlabDraw";
import sqftEventManager from "../../store/sqftEventManager";
import sqftImageManager from "../../store/sqftImageManager";
import sqftShapeManager from "../../store/sqftShapeManager";
import workspace from "../workspace";
import {MOVABLE_IMAGE_TYPES, SHAPE_PART_ID} from "../../../../constants";

export default class ResultImages {
  workspace;
  dimensionsMultiplier = 3;

  constructor(workspace) {
    this.workspace = workspace;
  }

  getCanvasImageScaled = () => {
    const isSlabMode = SqftStore.isSlabMode();
    let shouldReturnToSlabMode = false;
    if (isSlabMode) {
      enableRegularMode();
      store.dispatch(showSlabTool(false));
      shouldReturnToSlabMode = true;
    }

    const pointsMinMax = sqftShapeManager.getMinMaxShapesPointsOnWorkspace(this.workspace.getShapes());

    if (pointsMinMax.length > 0) {
      const minX = pointsMinMax[0].x;
      const minY = pointsMinMax[0].y;
      const maxX = pointsMinMax[2].x;
      const maxY = pointsMinMax[2].y;

      const offset = 200;
      const startPoint = {
        x: minX * config.defaultScaleExport - offset,
        y: minY * config.defaultScaleExport - offset
      }
      const clippingWidth = (maxX - minX) * config.defaultScaleExport + offset * 2;
      const clippingHeight = (maxY - minY) * config.defaultScaleExport + offset * 2;

      const resultImage = this.getCanvasScreen(
        config.defaultScaleExport,
        0,
        0,
        clippingWidth,
        clippingHeight,
        startPoint,
        this.updateCanvasAtStartPoint
      );

      //todo not needed to change back
      void shouldReturnToSlabMode
      // if (shouldReturnToSlabMode) {
      //   enableSlabMode();
      //   store.dispatch(showSlabTool(true));
      // }

      return resultImage;
    }

    return ""
  };

  getSlabResultImage = () => {
    const isSlabMode = SqftStore.isSlabMode();
    let shouldReturnToRegularMode = false;
    if (!isSlabMode) {
      enableSlabMode();
      store.dispatch(showSlabTool(true));
      shouldReturnToRegularMode = true
    }

    //1. Lets get only countertop shapes
    const shapesWithoutSlabImages = this.workspace.getShapesWithoutAttachedResources().filter(shp => {
      return shp.partId !== SHAPE_PART_ID.slabPlaceHolder
        && shp.type !== MOVABLE_IMAGE_TYPES.slabImage
    });

    //2. Now get minimum point
    const pointsMinMaxRegular = sqftShapeManager.getMinMaxShapesPointsOnWorkspace(shapesWithoutSlabImages, true);

    if (pointsMinMaxRegular.length > 0) {
      const minX = pointsMinMaxRegular[0].x;
      const minY = pointsMinMaxRegular[0].y;
      const maxX = pointsMinMaxRegular[2].x;
      const maxY = pointsMinMaxRegular[2].y;

      const workspacePos = workspace.getPosition();
      const offset = 200;

      //3. This is minimum point on field
      let startPoint = {
        x: (minX) * config.defaultScaleExport - offset - workspacePos.x,
        y: (minY) * config.defaultScaleExport - offset - workspacePos.y
      }

      //4.Canvas width
      const clippingWidth = (maxX - minX) * config.defaultScaleExport + offset * 2;
      const clippingHeight = (maxY - minY) * config.defaultScaleExport + offset * 2;

      //5.Lets distract canvas width (see renderSlabRightPart staticOffset)
      startPoint = {
        x: startPoint.x + clippingWidth / 2,
        y: startPoint.y
      }

      const resultImage = this.getCanvasScreen(
        config.defaultScaleExport,
        0,
        0,
        clippingWidth,
        clippingHeight,
        startPoint,
        this.updateCanvasSlab
      );

      if (shouldReturnToRegularMode) {
        enableRegularMode();
        store.dispatch(showSlabTool(false));
      }

      return resultImage
    }

    return ""
  };

  getSlabCalcImage = () => {
    const isSlabMode = SqftStore.isSlabMode();
    let shouldReturnToRegularMode = false;
    if (!isSlabMode) {
      enableSlabMode();
      store.dispatch(showSlabTool(true));
      shouldReturnToRegularMode = true
    }
    SlabWorkspace.disableSlabImages();

    const pointsMinMax = sqftShapeManager.getMinMaxShapesPointsOnWorkspace(this.workspace.getShapes());

    if (pointsMinMax.length > 0) {
      const minX = pointsMinMax[0].x;
      const minY = pointsMinMax[0].y;
      const maxX = pointsMinMax[2].x;
      const maxY = pointsMinMax[2].y;

      const offset = 200;
      const startPoint = {
        x: (minX) * config.defaultScaleExport - offset,
        y: (minY) * config.defaultScaleExport - offset
      }
      const clippingWidth = (maxX - minX) * config.defaultScaleExport + offset * 2;
      const clippingHeight = (maxY - minY) * config.defaultScaleExport + offset * 2;

      const resultImage = this.getCanvasScreen(
        config.defaultScaleExport,
        0,
        0,
        clippingWidth,
        clippingHeight,
        startPoint,
        this.updateCanvasAtStartPoint
      );

      if (shouldReturnToRegularMode) {
        enableRegularMode();
        store.dispatch(showSlabTool(false));
      }
      // else {
      //   SlabWorkspace.init();
      // }

      return resultImage
    }

    return ""
  }

  /**
   * Will return array of zoomed shape + AppliancesThatShouldRenderMeasurementsInsideTheShape images. One image per shape
   * @return {*}
   */
  getCanvasApplianceImages = () => {
    const applianceImages = sqftImageManager.getAppliancesThatShouldRenderMeasurementsInsideTheShape();
    const createdImagesForShapes = new Set();

    return applianceImages.reduce((result, applianceImage) => {
      const outerShape = applianceImage.getOuterShape();
      if (outerShape) {

        if (createdImagesForShapes.has(outerShape.id)) {
          return result;
        }

        createdImagesForShapes.add(outerShape.id);

        const outerShapePosition = outerShape.getPosition();
        let shapesPoints = outerShape.getPoints();
        let pointsMinMax = sqftShapeManager.getMinMaxPoints(shapesPoints, false);

        const offset = 200;
        const startPoint = {
          x: (outerShapePosition.x + pointsMinMax.minX) * config.defaultScaleExport - offset,
          y: (outerShapePosition.y + pointsMinMax.minY) * config.defaultScaleExport - offset
        };
        const clippingWidth = (pointsMinMax.maxX - pointsMinMax.minX) * config.defaultScaleExport + offset * 2;
        const clippingHeight = (pointsMinMax.maxY - pointsMinMax.minY) * config.defaultScaleExport + offset * 2;

        const canvasImage = this.getCanvasImage(config.defaultScaleExport,
          startPoint,
          clippingWidth,
          clippingHeight
        );
        result.push(canvasImage);
      }
      return result;
    }, []);
  };

  getCanvasImage = (newScale = config.defaultScaleExport, startPoint, imageWidth, imageHeight) => {
    const isSlabMode = SqftStore.isSlabMode();
    if (isSlabMode) {
      enableRegularMode();
      store.dispatch(showSlabTool(false));
    }

    return this.getCanvasScreen(
      newScale,
      0,
      0,
      imageWidth,
      imageHeight,
      startPoint,
      this.updateCanvasAtStartPoint
    );
  };

  getCanvasScreen = (newScale, startClippingX, startClippingY, clippingWidth, clippingHeight, centerPoint, updateCallback) => {
    // fix transparent background by drawing canvas onto another canvas with a white background
    // https://stackoverflow.com/questions/18609715/html5-canvas-todataurl-image-has-no-background-color

    const srcCanvas = this.workspace.getCanvas();
    const temp = {
      scale: config.scale,
      width: srcCanvas.width,
      height: srcCanvas.height,
    };
    updateCallback(srcCanvas, newScale, clippingWidth, clippingHeight, centerPoint);

    //create a dummy CANVAS
    const destinationCanvas = document.createElement("canvas");
    const destCtx = destinationCanvas.getContext('2d');
    destinationCanvas.width = srcCanvas.width ;
    destinationCanvas.height = srcCanvas.height ;

    //create a rectangle with the desired color
    destCtx.fillStyle = "#FFFFFF";
    destCtx.fillRect(0,0, destinationCanvas.width, destinationCanvas.height);

    //draw the original canvas onto the destination canvas
    if (clippingWidth > srcCanvas.width) clippingWidth = srcCanvas.width;
    if (clippingHeight > srcCanvas.height) clippingHeight = srcCanvas.height;

    destCtx.drawImage(
      srcCanvas,
      startClippingX,
      startClippingY,
      clippingWidth,
      clippingHeight,
      0,
      0,
      srcCanvas.width,
      srcCanvas.height
    );

    //restore canvas
    updateCallback(srcCanvas, temp.scale,  temp.width, temp.height, centerPoint);

    return destinationCanvas.toDataURL();
  }

  updateCanvas = (srcCanvas, scale, width, height, centerPoint) => {
    srcCanvas.width = width;
    srcCanvas.height = height;
    config.scale = scale;
    this.workspace.setCenter(centerPoint.width, centerPoint.height); // return canvas to default position
    sqftEventManager.trigger(sqftEventManager.events.RENDER);
    sqftEventManager.trigger(sqftEventManager.events.RENDER);
  }

  updateCanvasAtStartPoint = (srcCanvas, scale, width, height, startPoint) => {
    srcCanvas.width = width;
    srcCanvas.height = height;
    config.scale = scale;
    this.workspace.setPosition(startPoint); // return canvas to default position

    sqftEventManager.trigger(sqftEventManager.events.RENDER);
    sqftEventManager.trigger(sqftEventManager.events.RENDER);
  }

  updateCanvasSlab = (srcCanvas, scale, width, height, centerPoint) => {
    srcCanvas.width = width;
    srcCanvas.height = height;
    config.scale = scale;
    //this.workspace.setCenter(centerPoint.width, centerPoint.height); // return canvas to default position
    //this.workspace.setPosition({x: 0, y: 0}); // return canvas to default position NOTE setPosition will also update SlabWorkspace position
    SlabWorkspace.setPos(centerPoint); // return canvas to default position
    renderSlabRightPart(sqftEventManager.getCtx(), true);
  }
}
